//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "entercode",
  data() {
    return {
      code: "",
      phonenum: this.$store.state.user_info.phone || "",
      detail: {},
    };
  },
  created() {
    if (this.$route.query.key) {
      document.title = "重定向中";
      // this.$vux.loading.show();
      this.axios
        .post("/xcx/User/codeEnter", { id: this.$route.query.key })
        .then((res) => {
          if (res.data.data.is_exchange || res.data.data.is_buy) {
            // location.href='/dist/#/CatalogList?user_key='+localStorage.getItem('token')+'&id='+this.$route.query.key;
            this.axios.post("/xcx/Order/isSubscribe").then((res3) => {
              if (res3.data.subscribe) {
                location.href = `/dist/#/CatalogList?user_key=${this.$cookies.get(
                  "token"
                )}&id=${this.$route.query.key}`;
              } else {
                this.$router.replace({ name: "guanzhu" });
              }
            });
          } else {
            this.$router.replace({
              name: "tutorial",
              params: { showalert: true },
            });
          }
        });
    } else {
      this.axios
        .post("/xcx/Order/courseInfo", {
          course_id: this.$route.query.key || this.$route.query.id,
        })
        .then((res) => {
          this.detail = res.data.data.info;
        });
    }
  },
  methods: {
    enterCode() {
      let data = {
        code: this.code,
        phone:
          this.phonenum != ""
            ? this.phonenum
            : this.$store.state.user_info.phone,
        course_id: this.$route.query.id,
      };
      this.axios.post("/xcx/User/exchangeCode", data).then((res) => {
       this.$vux.toast.show({
            text: "兑换成功",
            type: "success",
          });
          this.axios.post("/xcx/Order/isSubscribe").then((res3) => {
            if (res3.data.subscribe) {
              location.href =
                "/dist/#/Home?user_key=" +
                this.$cookies.get("token") +
                "&id=" +
                this.$route.query.id;
            } else {
              this.$router.replace({ name: "guanzhu" });
            }
          });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/entercode/entercode.vue